import * as React from 'react';
import { useDispatch } from 'react-redux';
import { closeNotification } from '@gandi/notifications';
import { selectOneOrganizationLoaded, fetchOneOrganization } from '@gandi/redux-sharing';
import { sendCommerce } from '@gandi/tracking';
import { Drawer } from '@gandi/ui';
import { useAppSelector } from '../../hooks/useAppSelector';
import { retrieveCart, cleanupBrowserStorage } from '../../modules/actions';
import { selectCartIsActive, selectCartOwner, selectCartTotal, selectCartUUID, selectCartCurrency, selectCountTotalProducts } from '../../modules/selectors';
import { setCartWidgetVisibility } from '../../modules/widget/actions';
import { selectCartWidgetVisible } from '../../modules/widget/selectors';
import CartContent from './CartContent';
import ToggleButton from './ToggleButton';
import { NOTIFICATION_ID } from './modules/constants';
import { selectCountItems } from './modules/selectors';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "drawer": "CartWidget-drawer_2Hemg"
};
function CartWidget({
  bypassRetrieveCart = false,
  noCheckoutButton = false,
  noSuggestions = false,
  openable = true,
  openPreferences,
  preferences
}) {
  const visible = useAppSelector(selectCartWidgetVisible);
  const active = useAppSelector(selectCartIsActive);
  const cartOwner = useAppSelector(selectCartOwner);
  const isCartOwnerOrgaLoaded = useAppSelector(state => selectOneOrganizationLoaded(state, cartOwner || ''));
  const dispatch = useDispatch();
  const cartId = useAppSelector(selectCartUUID);
  const cartTotal = useAppSelector(selectCartTotal);
  const currency = useAppSelector(selectCartCurrency);
  const cartDistinctProducts = useAppSelector(selectCountItems);
  const cartProductsQuantity = useAppSelector(selectCountTotalProducts);
  React.useEffect(() => {
    if (!bypassRetrieveCart) {
      if (active) {
        dispatch(cleanupBrowserStorage());
      } else {
        dispatch(retrieveCart());
      }
    }
  }, []);
  React.useEffect(() => {
    if (cartOwner && !isCartOwnerOrgaLoaded) {
      dispatch(fetchOneOrganization(cartOwner));
    }
  }, [cartOwner, isCartOwnerOrgaLoaded, dispatch]);
  React.useEffect(() => {
    dispatch(setCartWidgetVisibility(false));
  }, []);
  React.useEffect(() => {
    dispatch(setCartWidgetVisibility(!openable));
  }, [openable, dispatch]);
  React.useEffect(() => {
    if (visible) {
      sendCommerce({
        name: 'cart.display',
        data: {
          cart_id: cartId,
          cart_currency: currency,
          cart_turnovertaxincluded: cartTotal.afterTaxes,
          cart_turnovertaxfree: cartTotal.beforeTaxes,
          cart_quantity: cartProductsQuantity,
          cart_nbdistinctproduct: cartDistinctProducts
        }
      });
    }
  }, [visible]);
  const hidePanel = () => dispatch(setCartWidgetVisibility(false));
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ToggleButton, {
      openable: openable,
      onClick: () => {
        if (openable) {
          dispatch(closeNotification(NOTIFICATION_ID));
          dispatch(setCartWidgetVisibility(true));
        }
      }
    }), openable && /*#__PURE__*/_jsx(Drawer, {
      open: visible,
      position: "right",
      modal: true,
      close: hidePanel,
      className: styles.drawer,
      children: /*#__PURE__*/_jsx(CartContent, {
        noCheckoutButton: noCheckoutButton,
        noSuggestions: noSuggestions,
        openable: openable,
        openPreferences: openPreferences,
        preferences: preferences,
        hidePanel: hidePanel
      })
    })]
  });
}
export default CartWidget;